import StakeDbPoolListCmp from '@/component/stake-db/pool/StakeDbPoolListCmp';

export default function StakeDbPoolList() {
  return <StakeDbPoolListCmp />;
}
